import "./services.css";

import {
  airFreightServicesTitile,
  airFreightServices,
  securityServices,
  charterAndComplianceSections,
} from "./text";

import SectionsCard from "../../Cards/SectionsCard";
import Reveal from "../../utils/Reveal";

import aircraft from "../../../assets/images/aircraft.png";

import dubai from "../../../assets/images/dubai.webp";

import aviationDetails from "../../../assets/images/aviation.jpg";
import { MultyTitileCard } from "../../Cards/MultyTitleSection";

const ScopeOfServices = () => {
  return (
    <>
      <h1 className=" text-center pb-5 header">Scope of Services</h1>
      <div className="container">
        <div className="row d-flex flex-wrap">
          <div className="col-lg-1"></div>
          <div className="col-lg-10">
            <div className="row d-flex flex-wrap">
              <div className="col-12 col-xl-6 about-us">
                <Reveal animationType="fadeInRight">
                  <SectionsCard
                    title={airFreightServicesTitile}
                    description={airFreightServices}
                    className="scopeOne-card"
                  />
                </Reveal>
              </div>
              <div className="col-12 col-xl-6">
                <div className="scopeOne-image" style={{ marginTop: "100px" }}>
                  <img src={aircraft} alt="" className="rounded img-fluid" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-1"></div>
        </div>
      </div>

      <div className="container scopeTwo-section">
        <div className="row d-flex flex-wrap">
          <div className="col-lg-1"></div>
          <div className="col-lg-10">
            <div className="row d-flex flex-wrap">
              <div className="col-12 col-xl-6 order-2 order-xl-1">
                <img src={dubai} alt="" className="w-100 rounded img-fluid" />
              </div>
              <div className="col-12 col-xl-6 order-1 order-xl-2 scopeTwo-description">
                <Reveal animationType="fadeInLeft">
                  <MultyTitileCard
                    sections={securityServices}
                    className="scopeTwo-card"
                  />
                </Reveal>
              </div>
            </div>
          </div>
          <div className="col-lg-1"></div>
        </div>
      </div>

      <div className="container scopeThree-section">
        <div className="row d-flex flex-wrap">
          <div className="col-lg-1"></div>
          <div className="col-lg-10">
            <div className="row d-flex flex-wrap">
              <div className="col-12 col-xl-6">
                <Reveal animationType="fadeInRight">
                  <MultyTitileCard
                    sections={charterAndComplianceSections}
                    className="scopeThree-card"
                    svgChild={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1440 320"
                        className="svg-addition"
                      >
                        <path
                          fill="#4472c4"
                          fillOpacity="1"
                          d="M0,128L60,149.3C120,171,240,213,360,208C480,203,600,149,720,128C840,107,960,117,1080,112C1200,107,1320,85,1380,74.7L1440,64L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"
                        ></path>
                      </svg>
                    }
                  />
                </Reveal>
              </div>
              <div className="col-12 col-xl-6 z-2">
                <div className="scopeThree-image">
                  <img src={aviationDetails} alt="" className=" w-100" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-1"></div>
        </div>
      </div>
    </>
  );
};

export default ScopeOfServices;
